const ZENDESK_ARTICLE_URL =
  "https://support.manifold.ai/hc/en-us/articles/43511727336461-Getting-Started-with-AI";
export const ZENDESK_HELP_URL = `/zendesk/sso?return_to=${encodeURIComponent(ZENDESK_ARTICLE_URL)}`;
